<template>
	<div>
		<el-drawer :modal="false" 
			:title="'Case: '+ _gHlp.getValue(product,'prod_case_no','N/A') "
			:visible.sync="is_visible"
			class="case-details-drawer"
			size="50%"
			@close="hide"
		>
			<div style="min-height:300px" v-loading="is_loading" element-loading-text="Optimize Case Detail..." class="cases-solicitor">
				<DisableCaseCard :product="product"/>
				<b-container  v-if="!_gHlp.isEmpty(product)">
          <template>
          <b-container style="min-width: 0 !important;">
            <b-row style="margin-top: 0;">
              <b-col cols="12">
                <StepProgress 
                  :steps="mySteps" 
                  :current-step="currentStep" 
                  icon-class="fa fa-check" 
                  active-color="#2dce89"
                  :active-thickness="3"
                  :passive-thickness="3"
                  :line-thickness="3"
                ></StepProgress>
              </b-col>
            </b-row>
          </b-container>
        </template>
				<el-tabs v-model="current_tab" style="margin-top: 4px;">

					<el-tab-pane label="Case Details" name="solicitor-case-details-tab">
						<SolicitorCaseDetailsTab :product="product"/>
					</el-tab-pane>

					<el-tab-pane label="Solicitors Details" name="solicitors_details">
						<SolicitorCaseDetails :product="product"/>
					</el-tab-pane>
	
					<el-tab-pane label="Documents" name="documents">
						<h3>Customer Documents</h3>
						<SolicitorDocuments ref="bankDocuments" :product_type="product.prod_type" :product_id="product.prod_id"  :customer_id="product.prod_customer_id"/>
					</el-tab-pane>
	
				</el-tabs>
				</b-container>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { Drawer, Collapse, CollapseItem, Button, Select, Option, DatePicker, Timeline, TimelineItem, Table, TableColumn } from 'element-ui'
import SolicitorCaseDetails from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/SolicitorCaseDetails/SolicitorDetails.vue'
import SolicitorCaseDetailsTab from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/SolicitorCaseDetails/SolicitorCaseDetailsTab.vue'
import DisableCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/DisableCaseCard'
import SolicitorDocuments from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/SolicitorCaseDetails/SolicitorDocuments.vue'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'        
import { Tabs, TabPane } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CurrencyInput from '@/components/CurrencyInput'
import StepProgress from 'vue-step-progress';

export default {
	components: {
		SolicitorDocuments,
		DisableCaseCard,
		SolicitorCaseDetails,
		SolicitorCaseDetailsTab,
    	StepProgress,
		[Drawer.name]: Drawer,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		[Button.name]: Button,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Timeline.name]: Timeline,
		[TimelineItem.name]: TimelineItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		ValidationObserver,
		ValidationProvider,
		CurrencyInput
	},
	data() {
		return {
			product:null,	
			is_visible: false,
			is_loading: false,
			activeNames:['1','2'],
			modals: {
				show_documents: false
			},
			current_tab: 'solicitors_details',
			form: {
				solicitor: '',
				payment_mode: ''
			},
			solicitorList: [
				{
					label: 'Gan & Zul',
					value: 'Gan & Zul',
				}
			],
			productList: [
				{
					label: 'Product',
					value: 'Product'
				}
			],
			statusList: [
				{
					label: 'Appointment Schedule',
					value: 'Appointment Schedule'
				}
			],
      buyerVendorSteps: [
        'Submit to Solicitor',
        'Pending Appointment',
        'SPA Signed',
        'SPA Received',
        'SPA Developer Signed',
        'Lawyer Collected',
        'SPA Stamped',
        'Vacant Possession',
      ],
      loanAgreementSteps: [
        'Submit to Solicitor',
        'LA Signed By Borrower',
        'LA Signed By Bank',
        'LOU Singed & Issued',
        'LA Stamped',
        'Advice Bank For 1st Draw Down',
        'First Disburse',
        'Full Disburse',
      ],
      buyerVendorMapping: {
        'Submit to Solicitor': 1,
        'Pending Appointment': 2,
        'SPA Signed': 3,
        'SPA Received': 4,
        'SPA Developer Signed': 5,
        'Lawyer Collected': 6,
        'SPA Stamped': 7,
        'Vacant Possession': 8,
      },
      loanAgreementMapping: {
        'Submit to Solicitor': 1,
        'LA Signed By Borrower': 2,
        'LA Signed By Bank': 3,
        'LOU Singed & Issued': 4,
        'LA Stamped': 5,
        'Advice Bank For 1st Draw Down': 6,
        'First Disbursement': 7,
        'Full Disbursement': 8,
      },
      currentStep: 0,
		}
	},
  computed: {
    // Dynamically get steps based on product type
    mySteps() {
      if (
        this.product?.product_detail?.prod_sol_type === 'Loan Agreement'
      ) {
        return this.loanAgreementSteps;
      }
      return this.buyerVendorSteps;
    },
    // Dynamically get status mapping based on product type
    statusMapping() {
      if (
        this.product?.product_detail?.prod_sol_type === 'Loan Agreement'
      ) {
        return this.loanAgreementMapping;
      }
      return this.buyerVendorMapping;
    },
  },
  created() {
    this.setCurrentStep(this.step_status);
  },
	methods: {
		...mapActions(useProductStore, ['getCustomerProducts','getProduct', 'checkCanGenerateCommision', 'generateProductCommission']),
    setCurrentStep(status) {
    if (this.product?.product_detail?.prod_sol_type === 'Loan Agreement') {
      // Use prod_sol_la_sub_status for Loan Agreement
      this.currentStep = this.statusMapping[status] || 0;
    } else {
      // Use prod_sol_spa_sub_status for Buyer and Vendor SPA
      this.currentStep = this.statusMapping[status] || 0;
    }
  },
    async show(product_id) {
			this.is_loading = true
			this.is_visible = true
			this.product = await this.getProduct(product_id);
      const statusField =
      this.product?.product_detail?.prod_sol_type === 'Loan Agreement'
        ? this.product?.product_detail?.prod_sol_la_sub_status
        : this.product?.product_detail?.prod_sol_spa_sub_status;

      this.setCurrentStep(statusField);
			this.is_loading = false
		},
		hide(){
			this.product = null
		},
		openDocumentsModal() {
			if (this.product && this.product.prod_customer_id) {
				this.modals.show_documents = true;
			} else {
				console.warn('Product or customer ID is not available yet.');
			}
		},
	}
}
</script>